import { render, staticRenderFns } from "./formio-test-builder.vue?vue&type=template&id=33774890"
import script from "./formio-test-builder.vue?vue&type=script&lang=js"
export * from "./formio-test-builder.vue?vue&type=script&lang=js"
import style0 from "./formio-test-builder.vue?vue&type=style&index=0&id=33774890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports